import Model from "./Model";
import {
  Company,
  User,
  ProductClass,
  ProductCategory,
  ProductSector,
  Media,
} from ".";

export default class Profile extends Model {
  static type = "profiles";

  name!: string;
  lastDate!: string;
  grpLastDate!: string | null;

  accountCompany!: Company;
  users!: User[];

  media?: Media;

  features!: string[];

  taxonomies!: Array<ProductSector | ProductCategory | ProductClass>;

  isAgency!: boolean;

  get company(): Company {
    if (this.isAgency) {
      //FiXmE: uGlY
      return (
        (this.users?.[0] && this.users[0].accountCompany) ?? ({} as Company)
      );
    } else {
      return this.accountCompany;
    }
  }

  set company(value: Company) {
    if (!this.isAgency) {
      this.accountCompany = value;
    }
  }

  hasFeature(feature: string) {
    return this.features.indexOf(feature) != -1;
  }
}
